import { Component, Inject, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet } from "@angular/material/bottom-sheet";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { Data } from "@angular/router";
import { AuthService } from '@core/auth.service';
import { encryptUsingAES256 } from "@core/utility.service";
import { BehaviorSubject } from "rxjs";
import { SocialService } from '../../../services/social.service';
import { MatTabGroup, MatTab, MatTabLabel } from "@angular/material/tabs";
import { InProgressAnimationComponent } from "../../in-progress-animation/in-progress-animation.component";
import { AsyncPipe } from "@angular/common";

@Component({
    selector: "app-community-subtabs",
    templateUrl: "./community-subtabs.component.html",
    styleUrls: ["./community-subtabs.component.scss"],
    standalone: true,
    imports: [
        MatTabGroup,
        MatTab,
        MatTabLabel,
        InProgressAnimationComponent,
        AsyncPipe,
    ],
})
export class CommunitySubtabsComponent implements OnInit, OnChanges {
  url1: SafeResourceUrl;
  url2: SafeResourceUrl;
  url3: SafeResourceUrl;
  url4: SafeResourceUrl;
  streamUrl: string;
  photoUrl: string;
  groupUrl: string;
  followerUrl: string;
  count: number;
  public wpId: number;
  $streamLoader = new BehaviorSubject("load");
  $photoLoader = new BehaviorSubject(false);
  $follwerLoader = new BehaviorSubject(false);
  $groupLoader = new BehaviorSubject(false);

  @Input() currentTab: number;
  urldata: string;
  constructor(
    private sanitizer: DomSanitizer,
    private sheet: MatBottomSheet,
    private auth: AuthService,
    private socialService: SocialService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: Data
  ) {
    this.count = -1;
    this.currentTab = data?.currentTab;
  }

  ngOnInit(): void {
    this.socialService.getGroup()
      .then(async (data) => {
        this.groupUrl = await data['group_detail']?.group_url;
        const encryptedToken =await encryptUsingAES256(localStorage.getItem("fbToken"))
        const groupURls= await `${this.groupUrl}&from=app&hide=true&token=${encryptedToken}` ;
        this.url4 = await this.sanitizer.bypassSecurityTrustResourceUrl(groupURls);
      })
      .catch((error) => {
        return error;
      });
    this.auth.userDetails$.subscribe((res) => {
      this.urldata = res?.peepso_profile_url;
      this.wpId = res?.wp_user_id;
    });

    const encryptedToken = encryptUsingAES256(localStorage.getItem("fbToken"));
    this.streamUrl = `https://web.lottosocial.com/activity?hide=true&from=app&token=${encryptedToken}`;
    this.url1 = this.sanitizer.bypassSecurityTrustResourceUrl(this.streamUrl);
    this.photoUrl =
      "https://web.lottosocial.com/profile/?" + this.wpId + `/photos&hide=true&from=app&token=${encryptedToken}`;
    this.url2 = this.sanitizer.bypassSecurityTrustResourceUrl(this.photoUrl);
    this.followerUrl =
      "https://web.lottosocial.com/profile/?" + this.wpId + `/followers&hide=true&from=app&token=${encryptedToken}`;
    this.url3 = this.sanitizer.bypassSecurityTrustResourceUrl(this.followerUrl);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes?.currentTab?.currentValue) {
      if (changes?.currentTab?.currentValue === 0) {
        this.currentTab = 0;
      } else if (changes.currentTab.currentValue === 1) {
        this.currentTab = 1;
      } else if (changes.currentTab.currentValue === 2) {
        this.currentTab = 2;
      } else if (changes.currentTab.currentValue === 3) {
        this.currentTab = 3;
      } else {
        this.currentTab = 0;
      }
    } else {
      this.currentTab = 0;
    }
  }
  loading(e: string) {
    this.count++;
    console.log(this.count);
    if (e == "stream") {
      if (this.count === 1) {
        this.count = 0;
        this.$streamLoader.next("notLoad");
      }
    }
  }
}
